<template>
  <div id="app">
    <Top />
    <router-view />
    <Footer />
  </div>
</template>
<script>
import Top from "@/views/Top.vue";
import Footer from "@/views/Footer.vue";
export default {
  components: {
    Top,
    Footer
  },
  created: function() {
    this.$store.dispatch("loadAllData");
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800&amp;subset=cyrillic");
</style>
<style src="bootstrap/dist/css/bootstrap.css"></style>
<style src="bootstrap-vue/dist/bootstrap-vue.css"></style>
<style>
.body, * {
  font-family: "tahoma";
}
.as-gallery {
  cursor: pointer;
}
.as-gallery .img_holder:hover {
  background: rgba(0, 0, 0, 0.1);
}
.as-main-carousel > span:first-child {
  position: absolute;
  display: block !important;
  background-color: #d24e1a;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  top: 35px;
  right: 50px;
  cursor: pointer;
}
.as-main-carousel > span:first-child:after {
  border-left-color: transparent;
  border-right-color: #fff;
  left: auto;
  right: 13px;
  content: "";
  position: absolute;
  top: 11px;
  left: 13px;
  border: 5px solid transparent;
  border-left-color: #fff;
}
.as-main-carousel > span:last-child {
  position: absolute;
  top: 35px;
  right: 85px;
  background-color: #d24e1a;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  display: block;
  cursor: pointer;
}
.as-main-carousel > span:last-child:after {
  content: "";
  position: absolute;
  top: 11px;
  left: 7px;
  border: 5px solid transparent;
  border-right-color: #fff;
}
.as-main-carousel .item {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
}
.as-main-carousel .item .img_holder {
  position: relative;
  z-index: 1;
}
.as-main-carousel .item .img_holder:after {
  position: absolute;
  z-index: 10;
  content: "";
  left: 0px;
  top: 0px;
  right: 100%;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  transition: all 0.5s cubic-bezier(0.04, 0.63, 0, 0.965);
}
.as-main-carousel .item:hover .img_holder:after {
  right: 0;
}
.as-main-carousel .item .img_holder img {
  height: 570px;
  object-fit: cover;
}
.as-main-carousel .item .title {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  z-index: 10;
  padding: 45px 50px 100px 50px;
  background: rgba(0, 0, 0, 0.6);
  background: -webkit-linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
  background: -o-linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
  background: -moz-linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
  background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
}
.as-main-carousel .item .view_more {
  position: absolute;
  z-index: 15;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 100px 50px 50px 50px;
  background: rgba(0, 0, 0, 0.6);
  background: -webkit-linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -o-linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: -moz-linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
}
.as-main-carousel .item .view_more a {
  display: inline-block;
  position: relative;
  border: 1px solid #eee;
  border-radius: 100px;
  padding: 0px 47px 0px 20px;
  line-height: 38px;
  color: #eee;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.as-main-carousel .item .view_more img {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -7px;
  width: 15px;
  height: 15px;
  transition: right 0.3s ease;
}
.as-main-carousel .item .abs_img {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.as-main-carousel .item .img_holder:after {
  background-color: rgba(0, 0, 0, 0.6);
}
.as-main-carousel a {
  text-decoration: none;
}
.as-main-carousel .item .title h3 a {
  color: #eee;
}
.top_bar {
  width: 100%;
  flex: 0 100%;
  display: flex;
  padding: 30px 30px;
}
.top_bar h3 {
  color: #fff;
  margin: 0;
  padding: 0;
  letter-spacing: 0;
  font-size: 30px;
  line-height: 40px;
  float: left;
  margin-right: 60px;
}
.top_bar span {
  position: relative;
  font-size: 14px;
  color: #bbb;
  letter-spacing: 0px;
  margin-left: 62px;
  min-height: 40px;
  display: flex;
  align-items: center;
}
.top_bar span:after {
  top: 0px;
  right: 100%;
  margin-right: 30px;
  width: 2px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.1);
  position: absolute;
  content: "";
}
.as-thanks-carousel > span:first-child {
  position: absolute;
  display: block !important;
  background-color: #d24e1a;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  top: 50px;
  right: 15px;
  cursor: pointer;
}
.as-thanks-carousel > span:first-child:after {
  border-left-color: transparent;
  border-right-color: #fff;
  left: auto;
  right: 13px;
  content: "";
  position: absolute;
  top: 11px;
  left: 13px;
  border: 5px solid transparent;
  border-left-color: #fff;
}
.as-thanks-carousel > span:last-child {
  position: absolute;
  top: 50px;
  right: 50px;
  background-color: #d24e1a;
  width: 30px;
  height: 30px;
  border-radius: 2px;
  display: block;
  cursor: pointer;
}
.as-thanks-carousel > span:last-child:after {
  content: "";
  position: absolute;
  top: 11px;
  left: 7px;
  border: 5px solid transparent;
  border-right-color: #fff;
}
.as-thanks-carousel .item .img_holder {
  position: relative;
  background: rgba(0, 0, 0, 0.5);
  border: 6px solid rgba(255, 255, 255, 0.75);
  margin-right: 5px;
  overflow: hidden;
}
.as-thanks-carousel .item .img_holder img {
  opacity: 0.5;
  height: 510px;
  width: auto;
}
.as-thanks-carousel .item .img_holder span {
  font-size: 24px;
  position: absolute;
  top: 30px;
  left: 30px;
  color: #fff;
}
.thanksLetters .top_bar {
  padding: 50px 0;
}
.blueimp-gallery a {
  color: #fff !important;
}
.blueimp-gallery .title,
.blueimp-gallery .description {
  opacity: 0;
  display: none;
}
.desc p span {
  font-weight: bold;
}
@media screen and (max-width: 789px) {
  .navbar-light .navbar-toggler {
    background: rgba(255, 255, 255, 0.75);
    border-radius: 0;
    border: 0;
    z-index: 1060;
  }

  #nav-collapse {
    z-index: 1050;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .navbar .navbar-nav {
    height: inherit;
    line-height: inherit;
  }
  #nav-collapse > * {
    width: 100%;
    background: #b2b2b2;
  }
  .as-slider .owl-item {
    text-align: center;
  }
  .as-slider img {
    width: auto;
    height: 100%;
  }
  .title_holder .title {
    font-size: 30px;
  }
  .block-about {
    padding: 30px 0 60px 0 !important;
  }
  .as-paralax {
    height: 320px !important;
  }
  .as-paralax .paralax-image {
    left: 7%;
  }
  .top_bar {
    padding: 5px !important;
  }
  .top_bar .t_inner > span {
    display: none;
  }
  .top_bar .t_inner h3 {
    float: unset;
    font-size: 24px;
  }
  .as-main-carousel > span:first-child,
  .as-thanks-carousel > span:first-child {
    top: 15px !important;
    right: 20px !important;
  }
  .as-main-carousel > span:last-child,
  .as-thanks-carousel > span:last-child {
    top: 15px !important;
    right: 60px !important;
  }
  .as-thanks-carousel .item .img_holder {
    margin-right: 0;
  }
  .as-thanks-carousel .owl-item .item {
    width: 70%;
    margin: 0 auto;
  }
  .as-thanks-carousel .item .img_holder img {
    height: 356px;
  }
  footer .footer_widget {
    float: unset;
    padding: 30px 0;
  }
  footer ul.widget_area {
    padding: 0 15px;
  }
  footer .footer_bottom_in {
    padding: 15px;
  }
  footer ul.widget_area > li {
    float: unset;
    width: 100%;
  }
  footer a.scrolled {
    top: 5px;
    margin-top: 0;
  }
  footer .widget_media_image {
    justify-content: center;
    display: flex;
  }
  .project-page .project-block {
    padding: 30px 0;
  }
  .project-page .project-block {
    padding: 30px 0 !important;
  }
  .ribbon2 {
    width: 60px;
  }
  .ribbon2:after {
    bottom: -20px;
    border-left: 30px solid #316397;
    border-right: 30px solid #316397;
    border-bottom: 20px solid transparent;
  }
  .navbar-brand img {
    max-height: 30px;
  }
}
</style>
